module.exports = __webpack_public_path__ + "static/media/bg.956809ba.png";